import {MatSnackBar} from '@angular/material/snack-bar';
import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class SnackbarService {
  constructor(private readonly snackBar: MatSnackBar) {}

  show(message: string, action?: string, duration?: number , panelClass?: string): void {
    this.snackBar.open(message, action || 'Close', {
      duration: duration || 3000,
      panelClass: panelClass || 'snackbar-global',
    });
  }
}
